import { ListOptionsFormController } from '@shared/list-options/list-options-form.controller';

import { CUSTOMER_LIST_COLUMN_LABEL_I18N_KEY } from '../customer-list/customer-list.config';
import { useCustomerListContext } from '../customer.context';

export const CustomerListOptionsController = (): React.JSX.Element => {
  const { columnOptions, setColumnOptions } = useCustomerListContext();

  return (
    <ListOptionsFormController
      columnOptions={columnOptions}
      columnLabelMap={CUSTOMER_LIST_COLUMN_LABEL_I18N_KEY}
      onChange={setColumnOptions}
    />
  );
};
